import React from 'react';
import PropTypes from 'prop-types';
import PrintSizeType from '../types/print-size-type';
import { builderDispatch } from '../../_utils/ui';
import CartItemsChangeEvents from '../cart-items-change-events';
import Currency from '../../_utils/tools/currency';
import CropWarning from '../crop-warning';
import pluralize from '../../_utils/tools/pluralize';
import genericHelpers from '../../_utils/generic-helpers';

const Summary = ({ sizes, quantity }) => {
  const totalPrice = sizes =>
    sizes.reduce((memo, size) => memo + size.total_price, 0);

  const sizesGroupedByFinish = sizes.reduce((sizesByFinish, size) => {
    const finish = size.finish;
    const currentFinish = sizesByFinish[finish] || {};
    const currentFinishSizes = currentFinish.sizes || [];

    return {
      ...sizesByFinish,
      ...{
        [finish]: {
          redirectParam: finish,
          finishParam: size.print_finish_key,
          sizes: [...currentFinishSizes, size],
        },
      },
    };
  }, {});

  return (
    <div>
      <div className="row">
        <div className="col-6">
          <h5>
            <b>{`${quantity} ${pluralize('Print', quantity)}`}</b>
          </h5>
        </div>
        <div className="col-6">
          <h4 className="price text-right">
            {Currency.format(totalPrice(sizes))}
          </h4>
        </div>
        <div className="col">
          <CropWarning />
        </div>
      </div>
      {Object.entries(sizesGroupedByFinish).map(([sizeFinish, printSize]) => {
        return (
          <div key={sizeFinish}>
            <table
              className="table table-striped prints-summary"
              data-test={`${sizeFinish}-prints-summary`}
              data-test-id={`${sizeFinish}-prints-summary`}>
              <thead className="thead-light">
                <tr>
                  <th>Size</th>
                  <th>Finish</th>
                  <th>Price</th>
                  <th>Qty</th>
                  <th>Total</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {printSize.sizes.map((size, i) => {
                  const printSizeTitle = size.title.replace(/\"|\s/g, '');

                  return (
                    <tr key={i}>
                      <td className="prints-summary__size-title">
                        {printSizeTitle + (size.print_border === "yes" ? " Bordered" : "")}
                      </td>
                      <td className="prints-summary__size-finish">
                        {genericHelpers.capitalizeString(size.finish)}
                      </td>
                      <td className="prints-summary__size-price">
                        {Currency.format(size.price)}
                      </td>
                      <td className="prints-summary__size-quantity">
                        {size.quantity}
                      </td>
                      <td className="prints-summary__size-total_price">
                        {Currency.format(size.total_price)}
                      </td>
                      <td>
                        <a
                          className="prints-summary__remove-btn"
                          aria-label={`Remove ${printSizeTitle} ${sizeFinish} ${pluralize(
                            'print',
                            size.quantity
                          )}`}
                          href="#"
                          onClick={handleIndividualDelete(size)}>
                          Remove
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="thead-light">
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th className="prints-summary__total-price">
                    {Currency.format(totalPrice(printSize.sizes))}
                  </th>
                  <th></th>
                </tr>
              </tfoot>
            </table>
            <p className="text-right pipe-delimit">
              <a
                className="prints-summary__edit-btn"
                aria-label={`Edit ${sizeFinish} prints`}
                href={`/order/prints-builder?finish=${printSize.redirectParam}`}>
                Edit
              </a>
              <a
                className="prints-summary__remove-all-btn"
                href="#"
                onClick={e => handleDelete(e, printSize.finishParam)}>
                Remove all&nbsp;
                <span className="prints-summary__remove-all-finish-type text-capitalize d-none">
                  {sizeFinish}&nbsp;
                </span>
                prints
              </a>
            </p>
          </div>
        );
      })}
    </div>
  );

  function handleDelete(e, finish) {
    e.preventDefault();

    builderDispatch.dispatch({
      type: CartItemsChangeEvents.REMOVE_PRINTS,
      finish: finish,
    });
  }

  function handleIndividualDelete(size) {
    return function(e) {
      e.preventDefault();
      builderDispatch.dispatch({
        type: CartItemsChangeEvents.REMOVE_PRINT,
        size: size,
      });
    };
  }
};

Summary.propTypes = {
  quantity: PropTypes.number.isRequired,
  sizes: PropTypes.arrayOf(PrintSizeType),
};

export default Summary;
